var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    className: "cls-1",
    d: "m22.65,21.23l-.88-.88c-.39-.39-.77-1.3-.77-1.85v-7.5c0-4.62-3.51-8.44-8-8.94v-1.06c0-.55-.45-1-1-1s-1,.45-1,1v1.06C6.51,2.56,3,6.38,3,11v7.5c0,.56-.37,1.46-.77,1.85l-.88.88c-.77.77-1.35,2.18-1.35,3.27v.5c0,.55.45,1,1,1h8v1c0,1.65,1.35,3,3,3s3-1.35,3-3v-1h8c.55,0,1-.45,1-1v-.5c0-1.09-.58-2.5-1.35-3.27Zm-9.65,5.77c0,.55-.45,1-1,1s-1-.45-1-1v-1h2v1Zm-10.93-3c.13-.5.4-1.06.69-1.35l.88-.88c.77-.77,1.35-2.18,1.35-3.27v-7.5c0-3.86,3.14-7,7-7s7,3.14,7,7v7.5c0,1.09.58,2.5,1.35,3.27l.88.88c.29.29.57.85.69,1.35H2.07Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.79bc2f2cf72f8dcb0c4d3393d16ed5ef.svg";
export { ForwardRef as ReactComponent };